export function contactError({ instagram = '', phone = '' }) {
  if (!instagram.trim() && !phone.trim()) return 'Renseignez votre Instagram ou votre numéro de téléphone (au moins un des deux).';
  if (instagram.trim() && !/^@?[a-zA-Z0-9._]{1,30}$/.test(instagram.trim())) return 'Indiquez votre identifiant Instagram, par exemple @votre_compte.';
  if (phone.trim() && !/^\+?[\d\s().-]+$/.test(phone.trim())) return 'Vérifiez votre numéro de téléphone.';
  if (phone.trim() && !/^\d{8,15}$/.test(phone.replace(/\D/g, ''))) return 'Vérifiez votre numéro de téléphone (8 à 15 chiffres).';
  return '';
}
export function contactNotes({ instagram = '', phone = '', notes = '' }) {
  return [instagram.trim() && `📱 Instagram: ${instagram.trim()}`, phone.trim() && `Téléphone: ${phone.trim()}`, notes.trim() && `ℹ️ Informations supplémentaires: ${notes.trim()}`].filter(Boolean).join('\n');
}
